var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_684_9244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.67517 0.668735C2.6764 0.392595 2.45354 0.167741 2.1774 0.166509C1.90126 0.165277 1.67641 0.388134 1.67518 0.664273L1.66914 2.01696C1.66688 2.5202 1.665 2.93995 1.70185 3.2774C1.7405 3.63136 1.8269 3.95758 2.04621 4.24096C2.1056 4.3177 2.17096 4.3895 2.24166 4.4557C2.28329 4.49469 2.32676 4.53173 2.37195 4.5667C2.65534 4.78601 2.98156 4.87241 3.33551 4.91106C3.67297 4.94791 4.09269 4.94603 4.59593 4.94377L5.94864 4.93773C6.22478 4.9365 6.44763 4.71165 6.4464 4.43551C6.44517 4.15937 6.22032 3.93651 5.94418 3.93774L4.62037 3.94365C4.08075 3.94606 3.7183 3.94692 3.44407 3.91697C3.42345 3.91472 3.40371 3.91233 3.38482 3.9098C3.66049 3.59898 3.96708 3.31618 4.29973 3.06625C5.33043 2.29186 6.61095 1.83317 8.00004 1.83317C11.4058 1.83317 14.1667 4.59408 14.1667 7.99984C14.1667 11.4056 11.4058 14.1665 8.00004 14.1665C4.59428 14.1665 1.83337 11.4056 1.83337 7.99984C1.83337 7.7237 1.60952 7.49984 1.33337 7.49984C1.05723 7.49984 0.833374 7.7237 0.833374 7.99984C0.833374 11.9579 4.042 15.1665 8.00004 15.1665C11.9581 15.1665 15.1667 11.9579 15.1667 7.99984C15.1667 4.0418 11.9581 0.833171 8.00004 0.833171C6.38693 0.833171 4.897 1.36672 3.69905 2.26676C3.33688 2.53886 3.00136 2.84448 2.69707 3.17902L2.69594 3.16884C2.66599 2.89461 2.66685 2.53216 2.66926 1.99254L2.67517 0.668735Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_684_9244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/RotateLeft.63196f92614658f5afe27196cacc011d.svg";
export { ForwardRef as ReactComponent };